import script from "./history-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./history-chart.vue?vue&type=script&lang=ts&setup=true"

import "./history-chart.vue?vue&type=style&index=0&id=153972d4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153972d4"]])

export default __exports__